export const otherRoutes = [
    {
        path: 'GeneralPages/Registration',
        route: 'registration-page',
    },
    {
        path: 'GeneralPages/Download',
        route: 'download-app',
    },
];
